var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReceiveDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_378_213467)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_378_213467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8546 21.8887C19.8546 22.441 19.4069 22.8887 18.8546 22.8887L1.06017 22.8887C0.507887 22.8887 0.060173 22.441 0.0601729 21.8887L0.0601728 19.9996C0.0601727 19.4473 0.507888 18.9996 1.06017 18.9996L18.8546 18.9996C19.4069 18.9996 19.8546 19.4473 19.8546 19.9996L19.8546 21.8887ZM1.795 10.2415C1.15855 9.61353 1.60324 8.52973 2.49737 8.52973L4.71574 8.52973C5.26802 8.52973 5.71574 8.08202 5.71574 7.52973L5.71574 1.15892C5.71574 0.606632 6.16345 0.158916 6.71574 0.158916L13.1991 0.158915C13.7514 0.158915 14.1991 0.606631 14.1991 1.15892L14.1991 7.52973C14.1991 8.08202 14.6468 8.52973 15.1991 8.52973L17.4175 8.52973C18.3116 8.52973 18.7563 9.61354 18.1198 10.2415L10.6598 17.6026C10.2704 17.9869 9.64446 17.9869 9.25504 17.6026L1.795 10.2415Z",
    fill: "#DADADA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_378_213467",
    x: 0.0601807,
    y: 0.15918,
    width: 19.7945,
    height: 23.7295,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_378_213467"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_378_213467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 23,
    fill: "white",
    transform: "translate(20 23) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReceiveDisabled);
export default __webpack_public_path__ + "static/media/icon_receive_disabled.05ed1e0397adad1057d9a5e1448cc63a.svg";
export { ForwardRef as ReactComponent };